export default {
  apiUrl: "https://dev-api.pf-flightpath.com",
  hmr: false
};
